import { NestedTreeControl } from '@angular/cdk/tree';
import { AfterViewInit, Component, Input, ViewChild } from '@angular/core';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { MenuService, OpcionMenu } from 'src/app/core/services/menu.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',

  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements AfterViewInit {


  // public recentModules!: OpcionMenu[];
  public isVisible = true;
  public current: string
  @Input() isSearch: boolean = false
  @ViewChild('tree') tree;

  treeControl = new NestedTreeControl<OpcionMenu>(node => node.rutas);
  menuOptions = new MatTreeNestedDataSource<OpcionMenu>();

  constructor(private router: Router, private helper: HelpersService, private menuService: MenuService) {
    this.current = location.hash.indexOf("#") == 0 ? location.hash.replace("#", "") : location.hash
    this.findMenuOptions()
  }

  ngAfterViewInit() {
    const interval = setInterval(() => {
      if (this.tree && this.tree.treeControl) {
        this.treeControl ? this.treeControl.dataNodes = this.menuOptions.data : ""
        this.tree.treeControl.expandAll();
        clearInterval(interval)
      }
    }, 500);
  }

  ngOnInit() {
  }

  /**
   * Busca las opciones del menú basado en la ruta actual
   */
  findMenuOptions() {
    const currentModule = this.menuService.getCurrentModuleOptions()
    const options = currentModule.opciones ? currentModule.opciones : []
    this.menuOptions.data = options
    // this.treeControl ? this.treeControl.dataNodes = options : ""

    if (options.length == 1 && options[0].ruta && (!options[0].rutas || options[0].rutas.length == 0)) {
      this.isVisible = false
      this.router.navigate([`/admin/${options[0].ruta}`])
    }
  }

  hasRutas(_: number, value: OpcionMenu): boolean {
    return value.rutas != undefined && Array.isArray(value.rutas) && value.rutas.length > 0;
  }
}

